import { Maybe } from 'maybe-not';
import setupQ2Elements from './setup/elements';
import loadDefaultTheme from './setup/styles/loadDefaultTheme';
import {
    designSystemTranslationSetup,
    DesignSystemLanguageAPI
} from './setup/designSystemTranslation';
import IDict from 'q2-tecton-common/lib/types/dict';

interface DesignSystemOptions {
    language?: string;
    translations?: IDict<IDict<string>>;
}

export function loadDesignSystem(
    options: DesignSystemOptions = {}
): Promise<DesignSystemLanguageAPI> {
    const teardowns: (() => void)[] = [];
    const normalizedOptions = {
        language: options.language,
        translations: options.translations || {}
    };
    // must load localization into setupQ2Elements
    // must provided functions for changing language
    const { loc, changeLanguage } = designSystemTranslationSetup(
        normalizedOptions.language,
        normalizedOptions.translations
    );

    // must load default styles
    const themePromise = loadDefaultTheme();
    const elementPromise = setupQ2Elements(
        loc,
        () => {
            return;
        },
        Maybe.nothing(),
        Maybe.nothing(),
        Maybe.nothing(),
        teardowns,
        Promise.resolve(Maybe.nothing())
    );

    return Promise.all([themePromise, elementPromise]).then(function() {
        return { loc, changeLanguage };
    });
}
